import { motion } from "framer-motion";
import { Plane, Sparkles, Users, Waves } from "lucide-react";
import { PILLARS } from "@/content";

const ICONS = { sparkles: Sparkles, waves: Waves, users: Users, plane: Plane };

export default function Services() {
  return (
    <section id="what-we-do" data-testid="what-we-do-section" className="bg-[#12281D] scroll-mt-20">
      <div className="mx-auto max-w-6xl px-5 py-20 lg:py-28">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
        >
          <p className="overline-gold mb-4">What We Do</p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#FBF9F1] leading-tight max-w-2xl">
            Experiences that hold space for{" "}
            <span className="gold-text italic">rest, sisterhood &amp; wonder.</span>
          </h2>
        </motion.div>
        <div className="mt-14 grid sm:grid-cols-2 gap-5">
          {PILLARS.map((p, i) => {
            const Icon = ICONS[p.icon];
            return (
              <motion.div
                key={p.title}
                data-testid={`pillar-card-${p.icon}`}
                initial={{ opacity: 0, y: 28 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.1 }}
                className="group rounded-3xl border border-[#D4AF37]/25 bg-[#1B3B2B]/60 p-8 hover:border-[#D4AF37]/60 hover:shadow-[0_0_25px_rgba(212,175,55,0.15)] transition-[border-color,box-shadow,transform] duration-300 hover:-translate-y-1"
              >
                <div className="w-12 h-12 rounded-2xl bg-[#D4AF37]/15 flex items-center justify-center mb-6 group-hover:bg-[#D4AF37]/25 transition-colors duration-300">
                  <Icon size={22} className="text-[#D4AF37]" />
                </div>
                <h3 className="font-serif text-2xl text-[#FBF9F1]">{p.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-[#D1DDD5]">{p.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
